import { DateTime } from 'luxon';

export const FormField = {
  dateRange: 'dateRange',
} as const;

export const MIN_DATE = DateTime.fromISO('2025-01-01');
// A function, not a module-load constant — a tab left open past midnight must not freeze "today".
export const getMaxDate = () => DateTime.now();
